export { default as Img200 } from './processed/200/Strike-Back-S7.jpg';
export { default as Img400 } from './processed/400/Strike-Back-S7.jpg';
export { default as Imgthumb } from './processed/thumb/Strike-Back-S7.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Strike-Back-S7.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Strike-Back-S7.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      220,
      44,
      52
    ],
    "_population": 18784,
    "_hsl": [
      0.9924242424242423,
      0.7154471544715447,
      0.5176470588235295
    ]
  },
  "LightVibrant": {
    "_rgb": [
      234,
      148,
      156
    ],
    "_population": 60,
    "_hsl": [
      0.9844961240310077,
      0.6718749999999997,
      0.7490196078431373
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      128,
      28,
      34
    ],
    "_population": 1431,
    "_hsl": [
      0.9900000000000001,
      0.641025641025641,
      0.3058823529411765
    ]
  },
  "Muted": {
    "_rgb": [
      138,
      74,
      76
    ],
    "_population": 218,
    "_hsl": [
      0.9947916666666666,
      0.3018867924528301,
      0.4156862745098039
    ]
  },
  "LightMuted": {
    "_rgb": [
      180,
      172,
      172
    ],
    "_population": 1,
    "_hsl": [
      0,
      0.050632911392405076,
      0.6901960784313725
    ]
  },
  "DarkMuted": {
    "_rgb": [
      92,
      57,
      58
    ],
    "_population": 96,
    "_hsl": [
      0.9952380952380953,
      0.23489932885906037,
      0.29215686274509806
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Strike-Back-S7.js